import First from "../../../../../assets/images/project/rumah//HNS_PIK2_HOUSE/00_pik2_cover.jpg";
import ke2 from "../../../../../assets/images/project/rumah//HNS_PIK2_HOUSE/01_pik2.jpg";
import ke3 from "../../../../../assets/images/project/rumah//HNS_PIK2_HOUSE/02_pik2.jpg";
import ke4 from "../../../../../assets/images/project/rumah//HNS_PIK2_HOUSE/03_pik2.jpg";

export default [
  {
    title: "Hns House",
    description: "Rumah Modern Kontemporer - PIK2",
    urls: First,
  },
  {
    title: "",
    description: "",
    urls: ke2,
  },
  {
    title: "",
    description: "",
    urls: ke3,
  },
  {
    title: "",
    description: "",
    urls: ke4,
  },
];
